import { cva } from 'class-variance-authority';

import {
  INTERACTIVE_STATES,
  GAP_SCALE,
  TYPE_SCALE,
  SIZE_SCALE,
  PADDING_X,
  CONTROL_ICON_SIZES,
} from '@/components/design-system/tokens';

export const toggleVariants = cva(
  `inline-flex items-center justify-center ${GAP_SCALE['2']} rounded-md ${TYPE_SCALE.sm} font-medium transition-colors ${INTERACTIVE_STATES.duration.normal} ${INTERACTIVE_STATES.focus.outline} ${INTERACTIVE_STATES.focus.ring} ${INTERACTIVE_STATES.focus.offset} ${INTERACTIVE_STATES.disabled.pointer} ${INTERACTIVE_STATES.disabled.opacity} [&_svg]:pointer-events-none ${CONTROL_ICON_SIZES.sm} [&_svg]:shrink-0`,
  {
    variants: {
      variant: {
        default:
          'bg-transparent hover:bg-muted hover:text-muted-foreground data-[state=on]:bg-accent data-[state=on]:text-accent-foreground',
        outline:
          'border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground data-[state=on]:bg-accent data-[state=on]:text-accent-foreground',
      },
      size: {
        default: `${SIZE_SCALE['9']} ${PADDING_X['2']} min-w-9`,
        sm: `${SIZE_SCALE['8']} ${PADDING_X['1.5']} min-w-8`,
        lg: `${SIZE_SCALE['10']} ${PADDING_X['2.5']} min-w-10`,
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
